/**
 * Store du site actif (filtre « siège »).
 *
 * Utilisé uniquement par les utilisateurs NON bornés à un site (siège /
 * administrateur) pour restreindre l'affichage à un emplacement précis. La
 * valeur est injectée dans l'en-tête HTTP `X-Site-Id` par l'intercepteur axios.
 *
 * En mémoire seulement (réinitialisé au rechargement / à la déconnexion) afin
 * d'éviter tout état de filtrage périmé entre sessions.
 */
import { create } from "zustand";

interface SiteState {
  activeSiteId: string | null;
  setActiveSiteId: (id: string | null) => void;
  reset: () => void;
}

export const useSiteStore = create<SiteState>((set) => ({
  activeSiteId: null,
  setActiveSiteId: (activeSiteId) => set({ activeSiteId }),
  reset: () => set({ activeSiteId: null }),
}));
